import React from "react";

function temperatureBarGradient(minF, maxF, weekMinF, weekMaxF) {
  if (
    minF == null ||
    maxF == null ||
    weekMinF == null ||
    weekMaxF == null
  ) {
    return "linear-gradient(to right, #6366f1, #f59e0b)";
  }
  const mid = (minF + maxF) / 2;
  const span = Math.max(weekMaxF - weekMinF, 1);
  const t = Math.min(1, Math.max(0, (mid - weekMinF) / span));
  if (t < 0.33) return "linear-gradient(to right, #3b82f6, #6366f1)";
  if (t < 0.55) return "linear-gradient(to right, #6366f1, #a855f7)";
  if (t < 0.75) return "linear-gradient(to right, #a855f7, #f59e0b)";
  return "linear-gradient(to right, #f59e0b, #ef4444)";
}

export default function TempRangeBar({
  minF,
  maxF,
  weekMinF,
  weekMaxF,
  className = "",
  trackClassName = "bg-[#192136]",
  heightClass = "h-2",
}) {
  let fillStyle = { left: "0%", width: "100%" };
  let dimmed = true;
  let gradient = temperatureBarGradient(minF, maxF, weekMinF, weekMaxF);

  if (
    minF != null &&
    maxF != null &&
    weekMinF != null &&
    weekMaxF != null
  ) {
    const span = Math.max(weekMaxF - weekMinF, 1);
    const left = ((minF - weekMinF) / span) * 100;
    const width = Math.max(((maxF - minF) / span) * 100, 8);
    fillStyle = {
      left: `${Math.min(left, 92)}%`,
      width: `${Math.min(width, 100 - left)}%`,
    };
    dimmed = false;
    gradient = temperatureBarGradient(minF, maxF, weekMinF, weekMaxF);
  }

  return (
    <div
      className={`relative w-full rounded-full ${heightClass} ${trackClassName} ${className}`}
    >
      <span
        className={`absolute top-0 block ${heightClass} rounded-full ${
          dimmed ? "opacity-30" : ""
        }`}
        style={{ ...fillStyle, background: gradient }}
      />
    </div>
  );
}
